import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useGetMe } from '@/hooks/useGetMe';
import { Button, PhoneNumberField } from '@scramble/ui';
import { VALIDATION_SCHEMA } from './schema';
import s from '../index.module.scss';

export const PhoneForm = ({ loading, disabled, onSubmit }) => {
  const { user } = useGetMe();
  const { t } = useTranslation();
  const { values, errors, touched, handleSubmit, setFieldValue } = useFormik({
    onSubmit,
    validationSchema: VALIDATION_SCHEMA(t),
    initialValues: {
      phone: user?.phone || '',
    },
  });

  return (
    <form className={s.modal} onSubmit={handleSubmit}>
      <div className={s.header}>
        <div className={s.title}>
          {t('modal:phone_verify_modal.account_security')}
        </div>
        <div className={s.desc}>
          {t('modal:phone_verify_modal.provide_phone_number')}
        </div>
      </div>

      <div className={s.content}>
        <div className={s.content_inner}>
          <PhoneNumberField
            name="phone"
            label={t('modal:phone_verify_modal.number', { required: '' })}
            placeholder={t('modal:phone_verify_modal.input_placeholder')}
            value={values.phone}
            countryPlaceholder={t(
              'modal:phone_verify_modal.country_placeholder',
            )}
            onChange={phone => setFieldValue('phone', phone)}
            onValidate={pass => setFieldValue('is_valid_phone', pass)}
            error={touched.phone && errors.is_valid_phone}
          />
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="filled"
          type="submit"
          className={s.btn_next}
          disabled={!values.is_valid_phone || disabled}
        >
          {loading
            ? t('modal:phone_verify_modal.sending_code')
            : t('modal:phone_verify_modal.send_verification_code')}
        </Button>
      </div>
    </form>
  );
};
